import { render, staticRenderFns } from "./MonthAllowancesPlanDetailsForm.vue?vue&type=template&id=25d8905c&"
import script from "./MonthAllowancesPlanDetailsForm.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports